import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';
import type { KYCStatus, KYCResponse } from '@/types/kyc';
import { getAuthHeaders } from '@/utils/getHeaders';
import { usePlayerStore } from '@/stores/player';
export const useKYCStore = defineStore('kyc', () => {
    const playerStore = usePlayerStore();
    const loadingFlag = ref<boolean>(false);
    const kyc = ref<KYCStatus>({
        completed: [],
        required: [],
        kyc_user_prompt_stage: null
    });
    const awaitGetKYCStatus = async () => {
        loadingFlag.value = true;
        try {
            const response = await axios.get<KYCStatus>('/main-api/kyc/', getAuthHeaders());
            if (response.status === 200) {
                kyc.value = response.data;
            }
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            loadingFlag.value = false;
        }
    };
    const awaitUploadPhoto = async (photo: string) => {
        try {
            const response = await axios.post<KYCResponse>('/main-api/kyc/tunduk/faceid', { photo }, getAuthHeaders());
            const { data, error_msg } = response.data;
            if (response.status === 200) {
                if (data && data.foto) {
                    const { is_citizen, message } = data.foto;
                    if (is_citizen) {
                        const parsedMessage = JSON.parse(message);
                        const actualMessage = parsedMessage.message || message || 'just_error';
                        console.log(actualMessage);
                        if (actualMessage.includes('NoFace')) {
                            throw new Error('no_face_error', { cause: 'no_face_error' });
                        } else if (
                            actualMessage.includes('NotVerified') ||
                            /* Success its means that person is citizen and cant play */
                            actualMessage.includes('Success')
                        ) {
                            pushCompleted('foto');
                            //console.log(data);
                            playerStore.toUpdatePlayerKYCStatus(data);
                            throw new Error('is_citizen_error', { cause: 'is_citizen_error' });
                        } else {
                            throw new Error(actualMessage);
                        }
                    } else {
                        pushCompleted('foto');
                    }
                } else if (error_msg) {
                    throw new Error(error_msg);
                }
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    function pushCompleted(item: string) {
        kyc.value.completed.push(item);
        kyc.value.required = kyc.value.required.filter((item) => item !== item);
    }
    return { kyc, awaitGetKYCStatus, awaitUploadPhoto, loadingFlag, pushCompleted };
});
